/**
 * @generated SignedSource<<5bfd3cb328831765768834eb8d9c499d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type RecordingMediaType = "AUDIO" | "VIDEO";
import { FragmentRefs } from "relay-runtime";
export type TranscriptModal_note$data = {
  readonly createdAt: string | null;
  readonly eventStart: string | null;
  readonly groupName: string;
  readonly id: string;
  readonly meetingRecordings: ReadonlyArray<{
    readonly __typename: "MeetingRecording";
    readonly activeSummary: {
      readonly id: string;
    } | null;
    readonly clips?: ReadonlyArray<{
      readonly id: string;
      readonly subtitlesVttUrl: string;
      readonly thumbnailVttUrl: string | null;
      readonly " $fragmentSpreads": FragmentRefs<"TranscriptVideo_meetingRecording">;
    }> | null;
    readonly hasExternalAttendees: boolean;
    readonly id: string;
    readonly isFavourite?: boolean;
    readonly mediaType: RecordingMediaType;
    readonly meetingCallEnd: string | null;
    readonly meetingCallStart: string;
    readonly meetingRecordedVideoUrl: string | null;
    readonly meetingVideoAndTranscriptionDownloadUrl: string | null;
    readonly ownerAccount: {
      readonly id: string;
    };
    readonly subtitlesVttUrl: string;
    readonly thumbnailVttUrl: string | null;
    readonly title: string;
    readonly viewerCanDelete: boolean;
    readonly " $fragmentSpreads": FragmentRefs<"RecapHistory_meetingRecording" | "Timeline_meetingKeyEvents" | "TranscriptModal_meetingRecording" | "TranscriptVideo_meetingRecording" | "utils_AddedOrAvailableUntil_meetingRecording" | "utils_useGetURL_recording" | "utils_useLongestMeetingRecording_meetingRecordings">;
  }> | null;
  readonly title: string;
  readonly " $fragmentSpreads": FragmentRefs<"HighlightsPanel_note" | "StatsPanel_note" | "TranscriptModalContent_note" | "utils_useAutoRefetchMeetingRecording_note" | "utils_useMeetingRecorderStatus_note">;
  readonly " $fragmentType": "TranscriptModal_note";
};
export type TranscriptModal_note$key = {
  readonly " $data"?: TranscriptModal_note$data;
  readonly " $fragmentSpreads": FragmentRefs<"TranscriptModal_note">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "subtitlesVttUrl",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "thumbnailVttUrl",
  "storageKey": null
},
v4 = [
  {
    "kind": "Variable",
    "name": "public",
    "variableName": "public"
  }
],
v5 = {
  "args": (v4/*: any*/),
  "kind": "FragmentSpread",
  "name": "TranscriptVideo_meetingRecording"
},
v6 = [
  (v0/*: any*/)
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "public"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "TranscriptModal_note",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "groupName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eventStart",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "MeetingRecording",
      "kind": "LinkedField",
      "name": "meetingRecordings",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        },
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "meetingCallStart",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "meetingCallEnd",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "meetingVideoAndTranscriptionDownloadUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "meetingRecordedVideoUrl",
          "storageKey": null
        },
        (v2/*: any*/),
        (v3/*: any*/),
        {
          "condition": "public",
          "kind": "Condition",
          "passingValue": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isFavourite",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "MeetingRecordingClip",
              "kind": "LinkedField",
              "name": "clips",
              "plural": true,
              "selections": [
                (v0/*: any*/),
                (v2/*: any*/),
                (v3/*: any*/),
                (v5/*: any*/)
              ],
              "storageKey": null
            }
          ]
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "viewerCanDelete",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasExternalAttendees",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "MeetingRecordingSummary",
          "kind": "LinkedField",
          "name": "activeSummary",
          "plural": false,
          "selections": (v6/*: any*/),
          "storageKey": null
        },
        {
          "args": (v4/*: any*/),
          "kind": "FragmentSpread",
          "name": "TranscriptModal_meetingRecording"
        },
        (v5/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "utils_useLongestMeetingRecording_meetingRecordings"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "utils_AddedOrAvailableUntil_meetingRecording"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "utils_useGetURL_recording"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "RecapHistory_meetingRecording"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "Timeline_meetingKeyEvents"
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "ownerAccount",
          "plural": false,
          "selections": (v6/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "mediaType",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "condition": "public",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "utils_useAutoRefetchMeetingRecording_note"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "utils_useMeetingRecorderStatus_note"
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HighlightsPanel_note"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "StatsPanel_note"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TranscriptModalContent_note"
    }
  ],
  "type": "Note",
  "abstractKey": null
};
})();

(node as any).hash = "c1cccaf4d1bb586aa330db76a1a86ae2";

export default node;
